export const formatName = (name: string): string => {
  const isPublicTest = window.preloaded.public_test;
  if (isPublicTest) {
    return name.replace(/_(RU|EU|ASIA|NA)$/i, '');
  }
  return name;
};
